module.exports = __webpack_public_path__ + "static/media/template_s1.197b2915.jpg";